<template>
  <b-card>
    <h4 class="card-title mb-4">
      {{ $t('pages.review.show.chart_title') }}
      <span class="text-muted"> ({{ $t('pages.review.show.last_days', {days: 90}) }})</span>
    </h4>
    <b-card-body>
      <apexchart
          v-if="!noData"
          class="apex-charts"
          height="340"
          type="pie"
          dir="ltr"
          :series="series"
          :options="chartOptions"
      ></apexchart>
      <no-content height="310px" v-else/>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: "ReviewPieChart",
  props: ['reviewPercent'],
  data() {
    return {
      series: [],
      chartOptions: {
        labels: [
          this.$t('pages.review.show.negative'),
          this.$t('pages.review.show.neutral'),
          this.$t('pages.review.show.negative')
        ],
        colors: ["#f46a6a", "#f1b44c", "#34c38f"],
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          verticalAlign: 'middle',
          floating: false,
          fontSize: '14px',
          offsetX: 0
        },
        responsive: [{
          breakpoint: 600,
          options: {
            chart: {
              height: 240
            },
            legend: {
              show: false
            },
          }
        }]
      }
    }
  },
  computed: {
    noData() {
      let nodata = true
      this.series.forEach((item) => {
        if (item > 0) {
          nodata = false
        }
      })
      return nodata
    }
  },
  watch: {
    reviewPercent(newVal) {
      if (newVal) {
        this.setPieChart()
      }
    }
  },
  methods: {
    setPieChart() {
      this.series = [this.reviewPercent.negative, this.reviewPercent.neutral, this.reviewPercent.positive]
    }
  }
}
</script>

<style scoped>

</style>